export default __webpack_public_path__ + "images/1622876828bbf447fae46b57935ebc74-airshow.jpg";